export class ComprovanteRenda {
  public tipoComprovante: string;
  public textoOutroComprovante: string;

  constructor(
    tipoComprovante?: string,
    textoOutroComprovante?: string,
  ) {
    this.tipoComprovante = tipoComprovante;
    this.textoOutroComprovante = textoOutroComprovante;
  }
}
